// Angular
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Router } from '@angular/router';

// Rxjs
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Services
import { AuthenticationService } from 'app/_services';
import { CedNotificationService } from 'ced-ng-library';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
        private cedNotificationService: CedNotificationService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(catchError(err => {
                if (err.status === 401) {
                    this.authenticationService.logout();
                    this.router.navigate(['/pages/login']);
                    return throwError('Unauthorized');
                }

                if(err.status == 500 || err.status == 0){
                    if(err.url.indexOf('/vecozo/search')>=0){
                        this.cedNotificationService.warning("NOTIFICATIONS.VECOZO_UNAVAILABLE");
                    }
                    if(err.error != null && err.error != undefined && typeof err.error === 'string'){
                        this.cedNotificationService.error(err.error);
                    }
                    else{
                    this.cedNotificationService.error("NOTIFICATIONS.INTERNAL_SERVER_ERROR");
                    }
                    throw err;
                }

                if (err.status == 400 ) {
                    if(err.url.indexOf('/SendSms')>=0){
                        this.cedNotificationService.warning("NOTIFICATIONS.SMS_ERROR")
                    }
                    else{
                        this.cedNotificationService.error("NOTIFICATIONS.BAD_REQUEST");
                    }
                    throw err;
                }

                if (err.status == 404) {
                    this.cedNotificationService.error(err.error, err.url)
                    throw err;

                }

            }));
    }
}
